// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth, GoogleAuthProvider } from "firebase/auth";

// Firebase configuration: prefer env vars, fallback to existing defaults
// Note: Client env vars must be prefixed with REACT_APP_
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || "AIzaSyDh160n7467VKeWKCaP1kxcKnpuEDeSugU",
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || "dstudio-25847.firebaseapp.com",
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || "dstudio-25847",
  // storageBucket should be the bucket name (typically <project-id>.appspot.com)
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || "dstudio-25847.firebasestorage.app",
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || "615810910808",
  appId: process.env.REACT_APP_FIREBASE_APP_ID || "1:615810910808:web:4586e9914732b20668182d",
  // Optional measurementId for GA4 if provided
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID as string | undefined,
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const auth = getAuth(app);
const googleProvider = new GoogleAuthProvider();

export { db, auth, googleProvider };
